(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/brand-cubes/assets/javascripts/brand-cubes.js') >= 0) return;  svs.modules.push('/components/accountservices-react/brand-cubes/assets/javascripts/brand-cubes.js');

'use strict';

var _svs;
svs = svs || {};
svs.accountservices_react = svs.accountservices_react || {};
svs.accountservices_react.brand_cubes = svs.accountservices_react.brand_cubes || {};
const {
  BrandCube
} = svs.components.lbUi.brandCube;
const isMomang = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 || (_svs = _svs.site) === null || _svs === void 0 ? void 0 : _svs.toLowerCase()) === 'momang';
const BrandCubes = function () {
  let {
    productId
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const productIds = isMomang ? [10004] : [72, 7, 10001, 45, 2, 33, 8, 6, 22, 10003, 28, 1, 25];
  const size = svs.core.detect.formfactor.mobile() ? 60 : 90;
  const style = {
    '--size': "".concat(size, "px")
  };
  let productsToShow = [];
  if (productId && productIds.includes(productId)) {
    productsToShow = [productId, productId, productId];
  } else if (isMomang) {
    productsToShow = [10004, 10004, 10004];
  } else {
    const uniqueProductIds = Array.from(new Set(productIds));
    while (productsToShow.length < 3 && uniqueProductIds.length > 0) {
      const idx = Math.floor(Math.random() * uniqueProductIds.length);
      productsToShow.push(uniqueProductIds.splice(idx, 1)[0]);
    }
  }
  return productsToShow.map((id, i) => React.createElement("div", {
    className: "brand-cube-wrapper brand-cube-wrapper-".concat(i),
    key: Math.random()
  }, React.createElement(BrandCube, {
    productId: id,
    style: style
  })));
};
svs.accountservices_react.brand_cubes.BrandCubes = BrandCubes;

 })(window);